import { render, staticRenderFns } from "./FormChangeMetaDataDatasource.vue?vue&type=template&id=049475c5&scoped=true&lang=pug"
import script from "./FormChangeMetaDataDatasource.vue?vue&type=script&lang=js"
export * from "./FormChangeMetaDataDatasource.vue?vue&type=script&lang=js"
import style0 from "./FormChangeMetaDataDatasource.vue?vue&type=style&index=0&id=049475c5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049475c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049475c5')) {
      api.createRecord('049475c5', component.options)
    } else {
      api.reload('049475c5', component.options)
    }
    module.hot.accept("./FormChangeMetaDataDatasource.vue?vue&type=template&id=049475c5&scoped=true&lang=pug", function () {
      api.rerender('049475c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/FormChangeMetaDataDatasource.vue"
export default component.exports